export default __webpack_public_path__ + "static/media/img6.844818a8.jpg";